/** Which editor the writing help is open for, and on which range. */
import { create } from 'zustand';
import type { Editor } from '@tiptap/core';

export interface WriteTarget {
  editor: Editor;
  from: number;
  to: number;
}

export const useAiWrite = create<{
  target: WriteTarget | null;
  open: (editor: Editor) => void;
  close: () => void;
}>((set) => ({
  target: null,
  open: (editor) => {
    const { from, to } = editor.state.selection;
    set({ target: { editor, from, to } });
  },
  close: () => set({ target: null }),
}));
